<template>
  <div>
    <div class="table">
      <table class="table table-bordered table-hover">
        <thead>
        <tr>
          <th>Tld</th>
          <th>Domain Count</th>
          <th>Price</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="tld in tlds" :key="tld.id">
          <td>{{ tld.tld }}</td>
          <td>{{ tld.domainCount }}</td>
          <td>
            <e-txt
              :text="tld.price || '/'"
              type="number"
              @input="updateProperty($event, tld.tld, 'price')"
              :close-on-save="true"
            ></e-txt>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import EditText from '../../../../Helpers/Form/EditText'

export default {
  data () {
    return {
      tlds: []
    }
  },
  components: {
    eTxt: EditText
  },
  mounted () {
    this.loadTlds()
  },
  methods: {
    loadTlds () {
      axios.get('/tlds?used=true')
        .then(r => {
          this.tlds = r.data.data.sort((a, b) => b.domainCount - a.domainCount)
        })
    },
    updateProperty (val, tld, prop) {
      let data = {}
      data[prop] = val
      axios.patch(`/tld/${tld}`, data)
        .then(r => {
          this.$toastr.success('Domain price updated')
          this.loadTlds()
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Billing/Tabs/Tlds.vue